<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddFundingTypeFlag" size="50%"
               :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="来源" prop="type" :label-width="formLabelWidth" style="width: 90%;">
                <el-radio-group v-model="addFrom.type">
                  <el-radio :label="1">自营</el-radio>
                  <el-radio :label="2">分销</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="业务名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.name" placeholder="请输入业务名称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="备注" prop="remark" :label-width="formLabelWidth">
                <el-input type="textarea" :min="4" v-model="addFrom.remark" placeholder="请输入备注"
                          clearable autosize style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="排序" :label-width="formLabelWidth">
                <el-input v-model="addFrom.weight" @input="validateInput(addFrom.weight)" placeholder="请输入排序" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width: 90%;">
                <el-radio-group v-model="addFrom.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";

export default {
  props: ['AddFundingTypeFlag', "editID"],
  components: {},
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      addFrom: {
        type: 1,
        weight: 0,
        name: "",
        remark: "",
        status: 1,
        id: "",
      }, rules: {
        type: [
          {required: true, message: '请选择收支类型', trigger: 'change'},
        ],
        name: [
          {required: true, message: '请输入业务名称', trigger: 'blur'},
        ],
        remark: [
          {required: true, message: '请输入收支名称', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],
      },
    };
  },
  created() {

  },
  methods: {
    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addFrom = {}
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    validateInput() {
      // 允许输入的正则表达式：0 或 正整数
      const regex = /^(0|[1-9]\d*)$/;

      // 检查输入值
      if (this.addFrom.weight && !regex.test(this.addFrom.weight)) {
        // 如果不符合要求，保留用户输入的最后有效值
        this.addFrom.weight = this.addFrom.weight.slice(0, -1);
      }
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let createText = ''
          if (this.addFrom.id == "") {
            createText = "创建成功";
          } else {
            createText = "修改成功";
          }

          if(this.addFrom.weight==null){
            this.addFrom.weight = 0
          }

          let api = MoneyManagementAPI()
          api.fundingTypeAdded(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: createText,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });

    }
  },

  mounted() {
    if (this.editID != "") {
      let api = MoneyManagementAPI()
      api.fundingTypeInfo(this.editID).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          this.addFrom = res.data
        } else {
          processErrors(res);
        }
      })
    }

  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>